/* eslint-disable max-len */
import React, { useContext } from 'react';
import classNames from 'classnames';

import { StoreContext } from '../../context/store-context';

import Modal from '../Modal/Modal';
import renderIcon from '../../utils/renderIcon';

const ns = 'alert-modal';

const AlertModal = ({
	positionRight,
}) => {
	const { alertModal, setAlertModal } = useContext(StoreContext);

	const closeModal = () => {
		setAlertModal(() => false);
	};

	const rootClassnames = classNames({
		[ns]: true,
	});

	const modalOverlayClassName = classNames({
		[`site-modal-overlay--alert`]: true,
	});
	const modalClassName = classNames({
		[`site-modal--alert`]: true,
		[`site-modal--right`]: positionRight,
	});

	return (
		<Modal
			contentLabel={'alert'}
			overlayClass={modalOverlayClassName}
			className={modalClassName}
			variant={`custom`}
			onRequestClose={closeModal}
			isOpen={alertModal}
		>
			<div className={rootClassnames}>
				<div className={`${ ns }__top`}>
					<i>{renderIcon('exclamation')}</i>
					<p>Account Temporarily Unavailable</p>
				</div>
				<div className={`${ ns }__body`}>
					<p>We are working to improve your sign-on experience!</p>
					<div>
						<strong>Placing an Order:</strong>
						<p>Please place your orders as a guest. To ensure your order is recorded in your account, please use the email address linked to your account.</p>
					</div>
					<div>
						<strong>Accessing Order History:</strong>
						<p>
							If you need to access your order history, please contact us at
							{' '}
							<span className={`phone`}>916-388-2838.</span>
						</p>
					</div>
					<div>
						<strong>Accessing Streaming Videos:</strong>
						<p>
							If you’re looking for streaming videos, please visit
							{' '}
							<a
								href={'https://eduvideo.pilates.com'}
								target={'_blank'}
								rel={'noreferrer'}
							>
								education videos
							</a>
							{' '}
							or
							{' '}
							<a
								href={'https://video.pilates.com'}
								target={'_blank'}
								rel={'noreferrer'}
							>
								videos
							</a>
						</p>
					</div>
					<div>
						<p>
							Please
							{' '}
							<a
								href={`mailto:info@pilates.com`}
								rel={`noreferrer`}
							>
								contact us
							</a>
							{' '}
							if you have any questions.
						</p>
					</div>
				</div>
			</div>
		</Modal>
	);
};

export default AlertModal;
